import { convertTimeStamp } from "utility/functions/convertTimestamp";
import { Space, Tooltip, Input } from "antd";
import {
  SwitcherOutlined,
  FormOutlined,
  AuditOutlined,
  FileSyncOutlined,
} from "@ant-design/icons";
import { orderStatus, shipStatus } from "utility/options/index";
const { TextArea } = Input;
const columns_all = ({ signUp, edit, resend, switchTicket, type }) => [
  {
    title: "功能",
    dataIndex: "action",
    key: "action",
    fixed: "left",
    type: [1, 2, 4],
    render: (text, record) => {
      return (
        <Space>
          <Tooltip title="人工簽到">
            <AuditOutlined onClick={() => signUp(record)} />
          </Tooltip>

          <Tooltip title="編輯">
            <FormOutlined onClick={() => edit(record)} />
          </Tooltip>

          <Tooltip title="補發票卷">
            <FileSyncOutlined onClick={() => resend(record)} />
          </Tooltip>
          {type === 4 && (
            <Tooltip title="換票">
              <SwitcherOutlined onClick={() => switchTicket(record)} />
            </Tooltip>
          )}
        </Space>
      );
    },
  },
  {
    title: "訂單編號 | 票號",
    dataIndex: "orderId",
    key: "orderId",
    type: [2, 4, 8, 16, 32],
  },
  {
    title: "票號",
    dataIndex: "id",
    key: "id",
    type: [2, 4, 8, 16, 32],
  },
  {
    title: "購買時間",
    dataIndex: "creationDate",
    key: "creationDate",
    type: [2, 4, 8, 16, 32],
    render: (text) => convertTimeStamp(text),
  },
  // {
  //   title: "數量",
  //   dataIndex: "amount",
  //   key: "amount",
  //   type: [2, 4, 8, 16, 32],
  // },
  {
    title: "姓名",
    dataIndex: "name",
    key: "name",

    type: [1, 2, 4, 8, 5, 16, 32],
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    type: [1, 2, 4, 8, 16, 32],
  },
  {
    title: "電話",
    dataIndex: "phone",
    key: "phone",
    type: [1, 2, 4, 8, 16, 32],
  },
  {
    title: "電影名稱",
    dataIndex: "title",
    key: "title",
    type: [1, 2, 4, 8, 16, 32],
  },
  {
    title: "價格",
    dataIndex: "price",
    key: "price",
    type: [1, 2, 4, 8, 16, 32],
  },
  {
    title: "票種",
    dataIndex: "ticketType",
    key: "ticketType",
    type: [1],
    render: (text) => (text == 1 ? "一般票種" : "免費票"),
  },
  {
    title: "備註",
    dataIndex: "remark",
    key: "remark",
    type: [1, 2, 4, 8, 16, 32],
  },
  {
    title: "簽到狀態",
    dataIndex: "shipStatus",
    key: "shipStatus",
    type: [1, 2, 4, 8, 16, 32],
    render: (text) => {
      let result = shipStatus.find((item) => item.value == text);
      return <p>{result?.label}</p>;
    },
  },
  {
    title: "付款狀態",
    dataIndex: "status",
    key: "status",
    type: [1, 2, 4, 8, 16, 32],
    render: (text) => {
      let result = orderStatus.find((item) => item.value == text);
      return <p>{result?.label}</p>;
    },
  },
  {
    title: "建立時間",
    dataIndex: "creationDate",
    key: "creationDate",
    type: [1],
    render: (text) => convertTimeStamp(text),
  },
];

export const Columns = ({ signUp, edit, resend, switchTicket, type }) => {
  let final = [];
  columns_all({ signUp, edit, resend, switchTicket, type }).map((item) => {
    if (item.type.includes(type)) {
      final.push(item);
    }
  });
  return final;
};
